import * as React from 'react';

import * as styles from './Column.css';

export const Column: React.FC = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};

Column.displayName = 'Column';
